// extracted by mini-css-extract-plugin
export default {"checkbox":"zLymet","checkboxInput":"A5vILz","inputsWrapper":"RPkwCI","fromPrice":"Vpf6SH","inputPrice":"vDqvdD","mobile":"R762wj"};